export const getOrderProducts = state => state.customer.profile.orderProducts || {}

export const isOfferListLoading = state => getOrderProducts(state).isOfferListLoading;
export const isPriceListLoading = state => getOrderProducts(state).isPriceListLoading;
export const getSelectedProduct = state => getOrderProducts(state).selected;
export const isSaving = state => getOrderProducts(state).isSaving;
export const getProductOffers = state => getOrderProducts(state).offers;
export const shouldSkipShippingOrder = state => getOrderProducts(state).skipShippingOrder;
export const getDisplayType = state => getOrderProducts(state).displayType;